<template>
  <div class="plk-basic-kpi">
    <div class="title text-center" :style="{ color: titleColor, fontSize: titleSize }" v-if="title.value || plkparams.showFiltersInHeader">
      {{$t(title.value)}} {{obtainFiltersLiteral(conditions)}}
    </div>
    <div class="values text-center p-2" v-for="(value, index) in values" :key="index">
      <i :title="value" class="icon" v-if="icon.class" :class="iconClass" :style="{ color: iconColor, fontSize: iconSize }"></i>
      <span class="value" :class="`item-${index}`" :style="{ color: valueColor, fontSize: titleSize }">
        {{value}}
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import services from '@/services'
import BasicComponentMixin from '@/mixins/component'
import configuration from './package.json'
import readme from './README.md'
export const TYPE = services.component.normalizeType('BasicKPI')

export default {
  name: TYPE,
  mixins: [
    BasicComponentMixin
  ],
  data () {
    return {
      loading: true,
      cube: undefined
    }
  },
  computed: {
    title () {
      return (this.plkparams.title || {})
    },
    value () {
      return (this.plkparams.value || {})
    },
    icon () {
      return (this.plkparams.icon || {})
    },
    titleColor () {
      return this.executeFunction((this.title.color || 'black'), this.cubeValues)
    },
    titleSize () {
      return this.executeFunction((this.title.size || '1.5rem'), this.cubeValues)
    },
    valueColor () {
      return this.executeFunction((this.value.color || 'black'), this.cubeValues)
    },
    valueSize () {
      return this.executeFunction((this.value.size || '1.5rem'), this.cubeValues)
    },
    iconColor () {
      return this.executeFunction((this.icon.color || 'black'), this.cubeValues)
    },
    iconSize () {
      return this.executeFunction((this.icon.size || '1.5rem'), this.cubeValues)
    },
    iconClass () {
      return this.executeFunction(this.icon.class, this.cubeValues)
    },
    values () {
      if (this.loading) {
        return [this.$t('plk.basicKPI.obtainingdata')]
      } else if (!this.cube) {
        return ['-']
      } else {
        return this.cubeValues
      }
    },
    cubeValues () {
      if (this.cube) {
        const values = Object.values(this.cube.getValues())
        const position = parseInt(this.value.item2show)
        return !values.length ? ['-'] : !isNaN(position) ? [values[position]] : values
      } else {
        return []
      }
    },
    dimension () {
      return this.plkparams.dimension
    },
    measure () {
      return this.plkparams.measure
    },
    conditions () {
      if (this.plkparams.conditions && this.plkparams.conditions.length) {
        return this.plkparams.conditions.map(c => {
          let condition = Object.assign({}, c)
          let filter = this.filters.find(f => f.idElement === condition.idElement)
          if (!condition.values && filter) {
            condition.values = filter.values
          } else if (!Array.isArray(condition.values)) {
            condition.values = this.executeFunction(condition.values, filter)
          } else if (!condition.values && !filter) {
            condition.values = []
          }
          return condition
        })
      } else {
        return this.filters
      }
    }
  },
  methods: {
    onDestroyComponent () {
      this.stopData()
    },
    startData () {
      if (this.getConnection() && this.dimension && this.dimension.type === this.getConnection().ELEMENT_TYPES.COLUMN && this.measure && this.measure.type === this.getConnection().ELEMENT_TYPES.MEASURE) {
        this.getConnection().initData([this.dimension, this.measure], this.conditions, { onInit: this.obtainData })
      } else {
        console.warn(`Necesary dimension type '${this.getConnection().ELEMENT_TYPES.COLUMN}' and  measure type '${this.getConnection().ELEMENT_TYPES.MEASURE}' to create ${TYPE}`)
      }
    },
    stopData () {
      if (this.connectionStarted) {
        this.getConnection().stopData({ onInit: this.onInitLoad, onChange: this.onChangeData })
      }
    },
    obtainData () {
      Vue.set(this, 'loading', true)
      this.getConnection().getDataByPage([this.dimension, this.measure], this.conditions).then(this.onChangeData)
    },
    onChangeData (cube) {
      Vue.set(this, 'cube', cube)
      this.cube.setElements({
        rows: this.columns,
        cols: [],
        filters: []
      })
      Vue.set(this, 'loading', false)
    },
    getPackage () {
      return configuration
    },
    getReadme () {
      return readme
    }
  },
  watch: {
    connectionStarted () {
      if (this.connectionStarted && this.getConnection().type === this.$servicesPLK.connection.TYPE.PLAKA) {
        this.startData()
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
